import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { saveAs } from 'file-saver';
import { isMobile } from 'react-device-detect';
import { Both, Contents, MultiPerPage, Orders } from '../constants';
import { formatDateTimeMMDDpm } from '../formatters';
import Request from './Request';
import { buildUnsignedVerbalsPrintPostData } from './unsignedVerbalsPrintDto';
// todo consider moving these util functions + constant configs out of this api file
export const DEFAULT_CERT_FONT_SIZE = '15px';
export const printBuffer = buffer => {
  const bufArray = Uint8Array.from(buffer);
  const blob = new Blob([bufArray], {
    type: 'application/pdf'
  });

  if (isMobile) {
    saveAs(blob, `Mumms - ${formatDateTimeMMDDpm(new Date())}.pdf`);
    return;
  }

  const blobURL = URL.createObjectURL(blob);
  const reactPdfIframe = document.querySelector('#react-pdf-iframe');

  if (reactPdfIframe) {
    document.body.removeChild(reactPdfIframe);
  }

  const iframe = document.createElement('iframe');
  iframe.id = 'react-pdf-iframe';
  iframe.style.display = 'none';
  iframe.src = blobURL;

  iframe.onload = () => {
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow && iframe.contentWindow.print();
    }, 1);
  };

  document.body.appendChild(iframe);
};
export const isFaxStatus = data => typeof data === 'object' && data !== null && 'isSuccess' in data && 'message' in data;
export const isChartJson = data => typeof data === 'object' && data !== null && data.printOutput === 'json';
export const isEmailStatus = data => typeof data === 'object' && data !== null && data.channel === 'email';
/** OP-33263: the cross patient compliance listing as the widget shows it (dates YYYY-MM-DD, site timezone). */

export class Printing extends Request {
  constructor({
    url,
    keycloak,
    agency,
    currentUser
  }) {
    super({
      url,
      keycloak
    });

    _defineProperty(this, "agency", void 0);

    _defineProperty(this, "currentUser", void 0);

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: '*'
    });

    _defineProperty(this, "printDaChart", async (printConfig, patient, sourceString, onProgress, faxInstructions, manifestRecord, emailInstructions, returnJson) => {
      const requestDto = _objectSpread({
        agency: this.agency,
        currentUser: this.currentUser,
        siteTimezone: this.currentUser.siteTimezone,
        dashboardPrintConfig: printConfig,
        patient,
        sourceString,
        faxInstructions,
        manifestRecord,
        emailInstructions
      }, returnJson ? {
        returnJson: true
      } : {});

      const response = await this.ws({
        api: 'print-da-chart',
        data: requestDto,
        onMessage: onProgress
      });
      return response;
    });

    _defineProperty(this, "completePrintConfig", {
      Facesheet: true,
      Bereavement: true,
      // {
      // TODO: in new ticket, enable notes checkbox for Beareavement in all environments + fix runoff bug on hbdemo bway pt 4781 print entire chart
      //   checkboxView: ['Notes'],
      // },
      CarePlanProblems: {
        view: 'Contents',
        notesMode: 'dateRange'
      },
      CarePlanFrequency: {
        notesMode: 'dateRange'
      },
      DocLink: {
        view: 'Card'
      },
      Manifest: {
        view: 'Contents'
      },
      PatientAssistance: {
        view: 'Details',
        notesMode: 'dateRange'
      },
      Measures: {
        view: 'Both'
      },
      ClearScripts: {
        view: 'All',
        notesMode: 'dateRange'
      },
      ProgressNotes: {
        view: 'Both'
      }
    });

    _defineProperty(this, "getEntireChartConfig", widgets => {
      const config = {};
      widgets.forEach(name => {
        config[name] = this.completePrintConfig[name];
      });
      return config;
    });

    _defineProperty(this, "printEntireChart", async (patient, widgets, onProgress, faxInstructions, emailInstructions) => {
      const response = await this.printDaChart(this.getEntireChartConfig(widgets), patient, 'Print the Chart', onProgress, faxInstructions, undefined, emailInstructions);
      return response;
    });

    _defineProperty(this, "printManifest", async (forms, patient, displayFacesheet, onProgress, faxInstructions, emailInstructions) => {
      const requestDto = {
        agency: this.agency,
        currentUser: this.currentUser,
        forms,
        patient,
        displayFacesheet,
        faxInstructions: faxInstructions,
        emailInstructions: emailInstructions
      };
      const response = await this.ws({
        api: 'print-manifest',
        data: requestDto,
        onMessage: onProgress
      });
      return response;
    });

    _defineProperty(this, "printIDGMeetingAgenda", async (forms, onProgress, faxInstructions, emailInstructions) => {
      const requestDto = {
        agency: this.agency,
        currentUser: this.currentUser,
        forms,
        displayFacesheet: false,
        faxInstructions: faxInstructions,
        emailInstructions: emailInstructions
      };
      const response = await this.ws({
        api: 'print-manifest',
        data: requestDto,
        onMessage: onProgress
      });
      return response;
    });

    _defineProperty(this, "printAssemblage", async (assemblage, onProgress, faxInstructions, emailInstructions) => {
      const requestDto = {
        agency: this.agency,
        currentUser: this.currentUser,
        assemblage,
        faxInstructions: faxInstructions,
        emailInstructions: emailInstructions
      };
      const response = await this.ws({
        api: 'print-assemblage',
        data: requestDto,
        onMessage: onProgress
      });
      return response;
    });

    _defineProperty(this, "printCurrentIdg", async (idgMeetingId, fromDate, toDate, patient, faxInstructions, emailInstructions) => {
      const response = await this.post({
        api: 'print-current-idg',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          idgMeetingId,
          fromDate,
          toDate,
          patient,
          faxInstructions: faxInstructions,
          emailInstructions: emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printCertifications", async (certForms, patient, complete, faxInstructions, fontSize, emailInstructions) => {
      const response = await this.post({
        api: 'print-certifications',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          dashboardPrintConfig: {
            DocLink: {
              view: 'Card'
            }
          },
          certForms,
          patient,
          complete,
          faxInstructions: faxInstructions,
          fontSize,
          emailInstructions: emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printVisits", async (visits, patient, faxInstructions, emailInstructions) => {
      const response = await this.post({
        api: 'print-visits',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          dashboardPrintConfig: {
            DocLink: {
              view: 'Card'
            }
          },
          visits,
          patient,
          faxInstructions: faxInstructions,
          emailInstructions: emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printMedications", async (pdfMedications, patient, pdfMedicationsNotes, hideBlankSections, renderNoOrdersText, faxInstructions, emailInstructions) => {
      const response = await this.post({
        api: 'print-medications',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          dashboardPrintConfig: {
            ClearScripts: {
              view: 'All',
              notesMode: 'dateRange'
            }
          },
          pdfMedications,
          pdfMedicationsNotes,
          patient,
          hideBlankSections,
          renderNoOrdersText,
          faxInstructions: faxInstructions,
          emailInstructions: emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "getProgressNotesView", type => {
      const defaultView = Both;

      if (type === Orders) {
        return [Orders, MultiPerPage];
      }

      return type || defaultView;
    });

    _defineProperty(this, "printOrdersAndNotes", async (ordersAndNotes, patient, type, faxInstructions, emailInstructions) => {
      const view = this.getProgressNotesView(type);
      const response = await this.post({
        api: 'print-orders-and-notes',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          dashboardPrintConfig: {
            ProgressNotes: {
              view
            }
          },
          ordersAndNotes,
          patient,
          faxInstructions: faxInstructions,
          emailInstructions: emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printUnsignedVerbals", async args => {
      const data = buildUnsignedVerbalsPrintPostData({
        agency: this.agency,
        currentUser: this.currentUser,
        unsignedVerbals: args.unsignedVerbals,
        patient: args.patient,
        dashboardPrintConfig: args.dashboardPrintConfig,
        sourceString: args.sourceString,
        faxInstructions: args.faxInstructions,
        emailInstructions: args.emailInstructions
      });
      const response = await this.post({
        api: 'print-unsigned-verbals',
        data
      });
      return response;
    });

    _defineProperty(this, "printVisitCompliance", async args => {
      var _this$currentUser;

      const response = await this.post({
        api: 'print-visit-compliance',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          siteTimezone: (_this$currentUser = this.currentUser) === null || _this$currentUser === void 0 ? void 0 : _this$currentUser.siteTimezone,
          sourceString: 'Visit Compliance - Cross Patient',
          visitCompliance: args.visitCompliance,
          faxInstructions: args.faxInstructions,
          emailInstructions: args.emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printCarePlanProblems", async (carePlanProblems, patient, carePlanProblemsNotes, faxInstructions, emailInstructions) => {
      const response = await this.post({
        api: 'print-care-plan-problems',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          dashboardPrintConfig: {
            CarePlanProblems: {
              view: Contents,
              notesMode: 'dateRange'
            }
          },
          carePlanProblems,
          carePlanProblemsNotes,
          patient,
          faxInstructions: faxInstructions,
          emailInstructions: emailInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printPdfFromBucket", async (pdfSlug, faxInstructions, patient) => {
      const response = await this.post({
        api: 'print-archived-pdf',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          siteTimezone: this.currentUser.siteTimezone,
          dashboardPrintConfig: {},
          pdfSlug,
          patient: patient || undefined,
          faxInstructions: faxInstructions
        }
      });
      return response;
    });

    _defineProperty(this, "printHtml", async (html, faxInstructions, patient, sourceString) => {
      const response = await this.post({
        api: 'print-html',
        data: {
          agency: this.agency,
          currentUser: this.currentUser,
          siteTimezone: this.currentUser.siteTimezone,
          dashboardPrintConfig: {},
          sourceString: sourceString || '',
          html,
          patient: patient || undefined,
          faxInstructions: faxInstructions
        }
      });
      return response;
    });

    this.url = new URL(url);
    this.keycloak = keycloak;
    this.agency = agency;
    this.currentUser = currentUser;
    Object.defineProperty(this.commonHeaders, 'Authorization', {
      get() {
        const {
          token
        } = keycloak;
        return `Bearer ${token}`;
      },

      set(newValue) {// need a setter
      }

    });
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API
  // has special logic to the printing service's protocol, but not much work to make
  // this a general websocket method in Request. We aren't using the full duplex capacity
  // of websockets here, since this is just a way for the server to notify the client its progress.
  async ws(args = {
    headers: {}
  }) {
    const {
      api,
      data,
      onMessage
    } = args;
    const protocol = window.env.config.websocketProtocol || 'wss';
    const url = `${protocol}://${this.url.host}/${api}`;
    await this.refreshToken(this.keycloak);
    const requestMessage = JSON.stringify(_objectSpread(_objectSpread({}, data), {}, {
      keycloakToken: this.keycloak.token,
      tokenParsed: this.keycloak.tokenParsed
    }));
    await this.refreshToken(this.keycloak);
    return new Promise(resolve => {
      const websocket = new WebSocket(url);

      websocket.onopen = () => {
        websocket.send(requestMessage);
      };

      websocket.onmessage = ({
        data: serverMessage
      }) => {
        const parsed = JSON.parse(serverMessage); // array: pdf bytes. fax/email status: dispatch result.
        // chart json: print-da-chart returnJson.

        if (Array.isArray(parsed) || isFaxStatus(parsed) || isEmailStatus(parsed) || isChartJson(parsed)) {
          resolve(parsed);
        } else if (onMessage) {
          onMessage(parsed);
        }
      };
    });
  } // needs own post method


  async post(args = {
    headers: {}
  }) {
    const {
      api,
      headers,
      data
    } = args;
    const url = `${this.url.href}${api}`;
    await this.refreshToken(this.keycloak);
    const body = JSON.stringify(_objectSpread(_objectSpread({}, data), {}, {
      keycloakToken: this.keycloak.token,
      tokenParsed: this.keycloak.tokenParsed
    }));
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: new Headers(_objectSpread(_objectSpread({}, this.commonHeaders), headers)),
      body
    }).then(res => res.json());
  }

}
export default Printing;